import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowRight, FaRegCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import "./Hero.css";
import { useLocalContext } from "../../context/LocalContext";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.75 } },
};

const fade = {
  hidden: { opacity: 0, scale: 0.98 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.75 } },
};

const Hero = () => {
  const navigate = useNavigate();
  const { webinfo = {} } = useLocalContext();

  const brand = webinfo?.name || "PrinterOffers.online";

  return (
    <section className="hro" aria-label="Introduction">
      <div className="hro__blob one" aria-hidden="true" />
      <div className="hro__blob two" aria-hidden="true" />

      <div className="hro__wrap">
        <div className="hro__grid">
          <motion.div initial="hidden" animate="show" variants={fadeUp}>
            <div className="hro__badge" aria-hidden="true">
              Digital marketing studio
            </div>

            <h1 className="hro__title">
              Grow visibility and leads with <span>honest digital marketing</span>.
            </h1>

            <p className="hro__sub">
              {brand} helps teams plan and run campaigns across search, paid media, social, email, and analytics. We scope
              work clearly, document assumptions, and avoid hype—we do not guarantee rankings, impressions, or revenue.
            </p>

            <ul className="hro__chips">
              <li>Written proposals &amp; timelines</li>
              <li>Platform-compliant messaging</li>
              <li>Privacy-conscious setup</li>
              <li>Reporting you can act on</li>
            </ul>

            <div className="hro__actions">
              <button type="button" className="hro__btn hro__btn--primary" onClick={() => navigate("/contact")}>
                Request a consultation <FaArrowRight aria-hidden />
              </button>

              <button type="button" className="hro__btn hro__btn--ghost" onClick={() => navigate("/services")}>
                View services
              </button>
            </div>

            <p className="hro__trust">
              <strong>Transparency:</strong> Ad platforms and algorithms change. Past performance does not ensure
              future results. Read our <Link to="/disclaimer">Disclaimer</Link> and{" "}
              <Link to="/privacy-policy">Privacy Policy</Link> before you share business data.
            </p>
          </motion.div>

          <motion.div className="hro__card" variants={fade} initial="hidden" animate="show">
            <div className="hro__cardTop">
              <div>
                <p className="hro__cardKicker">What we can help with</p>
                <h3 className="hro__cardTitle">Core offerings</h3>
              </div>
              <span className="hro__chip">Custom scopes</span>
            </div>

            <div className="hro__preview">
              <img
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=900&q=80"
                alt="Marketing analytics and growth charts on a laptop"
              />
            </div>

            <ul className="hro__list">
              <li>
                <span className="hro__tick">
                  <FaRegCheckCircle aria-hidden />
                </span>
                Strategy: goals, audiences, budgets, and channel mix
              </li>
              <li>
                <span className="hro__tick">
                  <FaRegCheckCircle aria-hidden />
                </span>
                SEO &amp; content: technical basics, topic planning, on-page structure
              </li>
              <li>
                <span className="hro__tick">
                  <FaRegCheckCircle aria-hidden />
                </span>
                Paid media: search, social, and display with conversion tracking
              </li>
              <li>
                <span className="hro__tick">
                  <FaRegCheckCircle aria-hidden />
                </span>
                Email, social, and dashboards tied to your KPIs
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
